import store from "../store";
function messageListener() {
  window.addEventListener("message", youyiListener, true);
}

function youyiListener(e) {
  if (e.data.func) {
    if (e.data.func == "givenConfig") {
      store.commit("setUserInfo", e.data.userInfo);
      store.commit("setGameData", e.data.gameData);
      const public_param = {
        game_id: e.data.gameData.game_id,
        access_token: e.data.userInfo.access_token,
        time: "",
        vest_id: e.data.gameData.vest_id,
        gv: "",
        sv: "",
        device_id: e.data.gameData.device_id,
        oaid: "",
        mac: "",
        android_imei: "",
        toutiao_channel: "",
        user_agent: "",
        os_type: "h5",
        is_box_review: e.data.gameData?.box_config?.is_box_review || 0,
        sign: "",
      };
      store.commit("SET_PUBLIC_PARAM", public_param);
    }
    if (e.data.func == "userInfoUpdated") {
      store.commit("setUserInfoUpdated", e.data.status);
    }
    if (e.data.func == "goToPath") {
      store.commit("setTarget", e.data);
    }
    if (e.data.func == "toPath") {
      store.commit("setTarget", e.data);
    }
  }
}

function readyNotify() {
  window.parent.postMessage({ func: "gameBoxReady" }, "*");
}
export { messageListener, readyNotify };
